import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
    breakpoints: {
        phone: 480,
        tablet: 768,
        laptop: 1200,
    }
})